import store from "src/store";
import ParametreGrupEnum from "src/enums/ParametreGrupEnum";

const getParametrePartsFind = (sortById: boolean, parametreGrupEnum: ParametreGrupEnum, pasifDahil: boolean) => {
    let res = store.getState().parameters.data?.filter(f => f.grupId === parametreGrupEnum);
    if (!pasifDahil)
        res = res.filter(f => f.aktif === "E");
    if (sortById)
        res = res.sort((a, b) => a.key - b.key)
    return res;
}
const getParametreIdPartsFind = (sortById: boolean, parametreGrupEnum: ParametreGrupEnum, pasifDahil: boolean) => {
    let res = store.getState().parametreId.data?.filter(f => f.grupId === parametreGrupEnum);
    if (!pasifDahil)
        res = res.filter(f => f.aktif === "E");
    if (sortById)
        res = res.sort((a, b) => a.key - b.key)
    return res;
}
const getParameterValue = (grup: ParametreGrupEnum, kodu: number): string => {
    return store.getState().parameters.data.find(f => f.grupId === grup && f.key === kodu)?.value;
}
export { getParametrePartsFind, getParameterValue,getParametreIdPartsFind };